/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  (function () {
    var selector = '[data-product-bundle-selector]';
    var nativeBundleTransformMarker = 'native-drip-v1';
    var nativeBundleComponents = {
      '52042186817857': [
        '51784035172673',
        '51944155939137'
      ]
    };

    function createBundleId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }

      return 'bundle-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    }

    function getSelectedOption(bundleSelector) {
      var selectedInput = bundleSelector.querySelector('[data-bundle-option-input]:checked');
      return selectedInput ? selectedInput.closest('[data-bundle-option]') : null;
    }

    function syncBundleSelector(bundleSelector) {
      var selectedOption = getSelectedOption(bundleSelector);

      bundleSelector.querySelectorAll('[data-bundle-option]').forEach(function (option) {
        var isSelected = option === selectedOption;
        var details = option.querySelector('[data-bundle-details]');

        option.classList.toggle('is-selected', isSelected);
        if (details) details.hidden = !isSelected;
      });
    }

    function getLineItemProperties(formData) {
      var properties = {};

      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (!match || match[1].indexOf('_bundle_') === 0 || value === '') return;
        properties[match[1]] = value;
      });

      return properties;
    }

    function setError(productRoot, message) {
      var errorContainer = productRoot.querySelector('[data-cart-errors-container]');
      if (!errorContainer) return;

      errorContainer.textContent = message || '';
      errorContainer.classList.toggle('is-visible', Boolean(message));
      if (message) {
        window.requestAnimationFrame(function () {
          errorContainer.focus({preventScroll: true});
        });
      }
    }

    function setButtonLoading(button, isLoading) {
      button.classList.toggle('is-loading', isLoading);
      button.disabled = isLoading;
    }

    function refreshCart(button) {
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.button = button;
        window.cart.getCart();
        return;
      }

      window.location.assign(window.theme.routes.cart_url);
    }

    function postCartItems(items) {
      return fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({items: items})
      }).then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok || body.status) {
            var error = new Error(body.description || body.message || body.errors);
            error.status = response.status;
            throw error;
          }
          return body;
        });
      });
    }

    function isNativeBundleAddonConflict(error) {
      return error &&
        error.status === 422 &&
        error.message === 'Bundle products and add-ons cannot be mixed';
    }

    function removeParentRelationships(items) {
      return items.map(function (item) {
        var flatItem = Object.assign({}, item);
        delete flatItem.parent_id;
        return flatItem;
      });
    }

    function buildNativeBundleTransformItems(parentVariantId, childVariantIds, quantity, bundleId, bundleType) {
      var componentVariantIds = nativeBundleComponents[parentVariantId];
      if (!componentVariantIds || !childVariantIds.length) return null;

      var parentVariantGid = 'gid://shopify/ProductVariant/' + parentVariantId;

      return componentVariantIds.map(function (componentVariantId) {
        return {
          id: componentVariantId,
          quantity: quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_type: bundleType,
            _bundle_role: 'component',
            _bundle_parent_variant_id: parentVariantGid,
            _bundle_transform_test: nativeBundleTransformMarker
          }
        };
      }).concat(childVariantIds.map(function (childVariantId) {
        return {
          id: childVariantId,
          quantity: quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_type: bundleType,
            _bundle_role: 'child',
            _bundle_parent_variant_id: parentVariantGid,
            _bundle_transform_test: nativeBundleTransformMarker
          }
        };
      }));
    }

    function orderBundleCartItems(root) {
      root.querySelectorAll('[data-items-holder]').forEach(function (holder) {
        var bundleParents = Array.prototype.slice.call(
          holder.querySelectorAll('[data-cart-item][data-bundle-role="parent"][data-bundle-id]')
        );

        bundleParents.forEach(function (parent) {
          var bundleId = parent.getAttribute('data-bundle-id');
          var matchingChild = Array.prototype.slice.call(
            holder.querySelectorAll('[data-cart-item][data-bundle-role="child"][data-bundle-id], [data-cart-item][data-bundle-role="drip-kit"][data-bundle-id]')
          ).find(function (child) {
            return child.getAttribute('data-bundle-id') === bundleId;
          });

          // Avoid reconnecting quantity counters that are already in the correct order.
          if (matchingChild && parent.nextElementSibling !== matchingChild) {
            holder.insertBefore(parent, matchingChild);
          }
        });

        var orderedItems = holder.querySelectorAll('[data-cart-item]');
        orderedItems.forEach(function (item, index) {
          item.classList.toggle('cart__item--no-border', index === orderedItems.length - 1);
          if (item.hasAttribute('data-aos-order')) {
            item.setAttribute('data-aos-order', index + 1);
          }
        });
      });
    }

    function addSelectedSetup(button, productRoot, bundleSelector) {
      var form = button.closest('form');
      var mainForm = productRoot.querySelector('[data-product-form]');
      var setup = productRoot.querySelector('[data-product-drip-setup]');
      var selectedOption = bundleSelector && getSelectedOption(bundleSelector);
      if (!form || !mainForm || (!setup && !selectedOption) || productRoot.dataset.setupAdding === 'true') return;
      if ((setup && setup.dataset.setupAvailable !== 'true') || (selectedOption && selectedOption.querySelector('input').disabled)) {
        setError(productRoot, (setup || bundleSelector).getAttribute('data-add-error'));
        return;
      }

      var formData = new FormData(form);
      var parentVariantId = setup ? setup.dataset.parentVariantId : String(formData.get('id') || new FormData(mainForm).get('id'));
      var dripVariantId = setup && setup.dataset.dripVariantId;
      var quantity = Math.max(1, Number(formData.get('quantity') || new FormData(mainForm).get('quantity') || 1));
      var bundleType = selectedOption ? selectedOption.getAttribute('data-bundle-option') : 'product-only';
      var childVariantIds = ((selectedOption && selectedOption.getAttribute('data-bundle-variant-ids')) || '')
        .split(',')
        .filter(Boolean);
      var bundleId = createBundleId();
      var parentProperties = getLineItemProperties(new FormData(mainForm));
      var isBundle = bundleType !== 'product-only';

      parentProperties._bundle_id = bundleId;
      parentProperties._bundle_type = bundleType;
      parentProperties._bundle_role = isBundle || dripVariantId ? 'parent' : 'standalone';
      if (setup && setup.dataset.sourceProductId) {
        parentProperties._bundle_source_product = setup.dataset.sourceProductId;
      }

      var items = [{
        id: parentVariantId,
        quantity: quantity,
        properties: parentProperties
      }];

      if (dripVariantId) {
        items.push({
          id: dripVariantId,
          quantity: quantity,
          parent_id: parentVariantId,
          properties: {
            _bundle_id: bundleId,
            _bundle_role: 'drip-kit'
          }
        });
      }

      if (isBundle) {
        childVariantIds.forEach(function (childVariantId) {
          items.push({
            id: childVariantId,
            quantity: quantity,
            parent_id: parentVariantId,
            properties: {
              _bundle_id: bundleId,
              _bundle_type: bundleType,
              _bundle_role: 'child'
            }
          });
        });
      }

      var nativeBundleTransformItems = !setup && isBundle && buildNativeBundleTransformItems(
        parentVariantId,
        childVariantIds,
        quantity,
        bundleId,
        bundleType
      );

      if (nativeBundleTransformItems) {
        items = nativeBundleTransformItems;
      }

      productRoot.dataset.setupAdding = 'true';
      setButtonLoading(button, true);
      setError(productRoot, '');

      postCartItems(items)
        .catch(function (error) {
          if (setup || !isBundle || !isNativeBundleAddonConflict(error)) throw error;
          return postCartItems([items[0]]).then(function () {
            return postCartItems(removeParentRelationships(items.slice(1)));
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('theme:cart:add', {
            bubbles: true,
            detail: {selector: button}
          }));
          refreshCart(button);
        })
        .catch(function () {
          setError(productRoot, (setup || bundleSelector).getAttribute('data-add-error'));
        })
        .finally(function () {
          delete productRoot.dataset.setupAdding;
          setButtonLoading(button, false);
        });
    }

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-bundle-option-input]')) return;
      syncBundleSelector(event.target.closest(selector));
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-add-to-cart]');
      if (!button || button.disabled) return;

      var productRoot = button.closest('[data-product]');
      var bundleSelector = productRoot && productRoot.querySelector(selector);
      if (!bundleSelector && !(productRoot && productRoot.querySelector('[data-product-drip-setup]'))) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addSelectedSetup(button, productRoot, bundleSelector);
    }, true);

    document.addEventListener('submit', function (event) {
      if (!event.target.matches('[data-product-form]')) return;
      var productRoot = event.target.closest('[data-product]');
      var bundleSelector = productRoot && productRoot.querySelector(selector);
      if (!productRoot || (!bundleSelector && !productRoot.querySelector('[data-product-drip-setup]'))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var button = event.submitter || event.target.querySelector('[data-add-to-cart]');
      if (button && !button.disabled) addSelectedSetup(button, productRoot, bundleSelector);
    }, true);

    var cartNeedsHistoryRefresh = false;

    window.addEventListener('pageshow', function (event) {
      var navigation = window.performance.getEntriesByType('navigation')[0];
      cartNeedsHistoryRefresh = Boolean(event.persisted || (navigation && navigation.type === 'back_forward'));
    });

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-cart-drawer-toggle]');
      if (!cartNeedsHistoryRefresh || !toggle || !window.cart || window.cart.isCartDrawerOpen) return;
      if (!document.querySelector('[data-product-drip-setup], [data-product-bundle-selector]')) return;

      // History can restore the empty drawer template from before the setup was added.
      event.preventDefault();
      event.stopImmediatePropagation();
      cartNeedsHistoryRefresh = false;
      refreshCart(null);
    }, true);

    function initializeBundleSelectors(root) {
      root.querySelectorAll(selector).forEach(syncBundleSelector);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeBundleSelectors(document);
        orderBundleCartItems(document);
      });
    } else {
      initializeBundleSelectors(document);
      orderBundleCartItems(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeBundleSelectors(event.target);
      orderBundleCartItems(event.target);
    });

    document.addEventListener('theme:cart:loaded', function () {
      orderBundleCartItems(document);
    });

    document.addEventListener('theme:cart:added', function () {
      orderBundleCartItems(document);
    });
  })();


  (function () {
    var isoCode = window.theme && window.theme.current_iso_code;
    var isExplicitCurrency = isoCode && isoCode !== 'USD';
    var originalFormatMoney = window.theme && window.theme.formatMoney;
    var observedProgressBar;
    var progressBarObserver;
    var priceSelectors = [
      '#rebuy-cart .rebuy-cart__flyout-item-price',
      '#rebuy-cart .rebuy-cart__flyout-subtotal',
      '#rebuy-cart [data-rebuy-component="cart-subtotal"]',
      '#rebuy-cart [data-rebuy-component="progress-bar"]',
      '#rebuy-cart .rebuy-cart__progress-bar-prompt',
      '#rebuy-cart .rebuy-product-price'
    ].join(',');

    function stripTrailingZeros(value) {
      return String(value).replace(/([.,]00)(?=(?:\s|&nbsp;)*(?:[A-Z]{3})?(?:\s|&nbsp;)*$)/, '');
    }

    function formatRebuyPriceText(text) {
      if (!text) return text;

      return text.replace(/((?:AU\$|CA\$|A\$|C\$|[$€£¥₡₱₹₩₪₫₭₦₨])\s*\d(?:[\d,.'’]|\s+(?=\d))*)(?:\s*([A-Z]{3}))?/g, function (match, amount, currencyCode) {
        var formattedAmount = stripTrailingZeros(amount).trim();

        if (!isExplicitCurrency) return formattedAmount;

        return formattedAmount + ' ' + (currencyCode || isoCode);
      });
    }

    function formatRebuyElement(element) {
      if (!element) return;

      var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      var textNode;

      while ((textNode = walker.nextNode())) {
        var updatedText = formatRebuyPriceText(textNode.nodeValue);
        if (updatedText !== textNode.nodeValue) {
          textNode.nodeValue = updatedText;
        }
      }
    }

    function formatRebuyCartPrices() {
      document.querySelectorAll(priceSelectors).forEach(formatRebuyElement);
      syncRebuyProgressBarVisibility();
    }

    function syncRebuyProgressBarVisibility() {
      var goalBox = document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="goalBox"]');
      var progressBar = goalBox && goalBox.querySelector('[data-rebuy-component="progress-bar"].ge-hide');

      if (progressBar !== observedProgressBar) {
        if (progressBarObserver) progressBarObserver.disconnect();

        observedProgressBar = progressBar;

        if (progressBar) {
          progressBarObserver = new MutationObserver(syncRebuyProgressBarVisibility);
          progressBarObserver.observe(progressBar, {
            attributes: true,
            attributeFilter: ['class', 'style']
          });
        }
      }

      if (goalBox) {
        var isHiddenByGlobalE = progressBar && window.getComputedStyle(progressBar).visibility === 'hidden';
        goalBox.classList.toggle('is-global-e-hidden', Boolean(isHiddenByGlobalE));
      }
    }

    if (window.theme && window.theme.settings) {
      window.theme.settings.currency_code_enable = Boolean(isExplicitCurrency);
    }

    if (window.theme && typeof originalFormatMoney === 'function' && !window.theme.formatMoney.__globalEWrapped) {
      window.theme.formatMoney = function (cents, format) {
        var formatToUse = format;

        if (!isExplicitCurrency && format === window.theme.moneyWithCurrencyFormat) {
          formatToUse = window.theme.moneyFormat;
        }

        return stripTrailingZeros(originalFormatMoney.call(this, cents, formatToUse));
      };

      window.theme.formatMoney.__globalEWrapped = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', formatRebuyCartPrices);
    } else {
      formatRebuyCartPrices();
    }

    new MutationObserver(function () {
      window.requestAnimationFrame(formatRebuyCartPrices);
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  })();

(function () {
  var componentName = 'me-collection-card-gallery';
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  if (window.__meCollectionCardGalleryInitialized) return;
  window.__meCollectionCardGalleryInitialized = true;

  function galleryIsActive() {
    return mobileQuery.matches;
  }

  function syncComponents() {
    document.querySelectorAll(componentName).forEach(function (component) {
      if (typeof component.sync === 'function') component.sync();
    });
  }

  class MECollectionCardGallery extends HTMLElement {
    constructor() {
      super();

      this.mounted = false;
      this.activeIndex = 0;
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.horizontalDrag = false;
      this.scrollFrame = null;
      this.snapTimer = null;
      this.visibleImage = null;
      this.visibleImageSource = '';
      this.onScroll = this.onScroll.bind(this);
      this.onScrollEnd = this.onScrollEnd.bind(this);
      this.onPagerClick = this.onPagerClick.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onMediaClick = this.onMediaClick.bind(this);
      this.onSwatchClick = this.onSwatchClick.bind(this);
      this.onSwatchKeyup = this.onSwatchKeyup.bind(this);
      this.onGridImageMutation = this.onGridImageMutation.bind(this);
    }

    connectedCallback() {
      this.template = this.querySelector('[data-me-collection-card-gallery-template]');
      this.mediaLink = this.querySelector('.product__media__holder');
      this.productBlock = this.closest('[data-product-block]');
      this.collectionProducts = this.closest('[data-collection-products]');
      this.sync();
    }

    disconnectedCallback() {
      this.unmount();
    }

    sync() {
      if (!this.template || !this.mediaLink || !this.collectionProducts) return;

      if (galleryIsActive()) {
        this.mount();
        return;
      }

      this.unmount();
    }

    mount() {
      if (this.mounted) return;

      var fragment = this.template.content.cloneNode(true);
      this.track = fragment.querySelector('[data-me-collection-card-gallery-track]');
      this.pager = fragment.querySelector('[data-me-collection-card-gallery-pager]');

      if (!this.track || !this.pager) return;

      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-me-collection-card-gallery-slide]'));
      this.pagerButtons = Array.prototype.slice.call(this.pager.querySelectorAll('[data-me-collection-card-gallery-index]'));

      if (this.slides.length < 2 || this.pagerButtons.length !== this.slides.length) return;

      this.mediaLink.appendChild(this.track);
      this.appendChild(this.pager);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('scrollend', this.onScrollEnd, { passive: true });
      this.track.addEventListener('pointerdown', this.onPointerDown, { passive: true });
      this.track.addEventListener('pointermove', this.onPointerMove, { passive: true });
      this.mediaLink.addEventListener('click', this.onMediaClick);
      this.pager.addEventListener('click', this.onPagerClick);

      if (this.productBlock) {
        this.productBlock.addEventListener('click', this.onSwatchClick);
        this.productBlock.addEventListener('keyup', this.onSwatchKeyup);
      }

      var featuredContainer = this.querySelector('[data-product-media-featured]');
      if (featuredContainer) {
        this.gridImageObserver = new MutationObserver(this.onGridImageMutation);
        this.gridImageObserver.observe(featuredContainer, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true
        });
      }

      this.mounted = true;
      this.onGridImageMutation();
      this.setActive(0);
    }

    unmount() {
      if (!this.mounted) return;

      if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
      if (this.snapTimer) window.clearTimeout(this.snapTimer);
      if (this.gridImageObserver) this.gridImageObserver.disconnect();

      this.track.removeEventListener('scroll', this.onScroll);
      this.track.removeEventListener('scrollend', this.onScrollEnd);
      this.track.removeEventListener('pointerdown', this.onPointerDown);
      this.track.removeEventListener('pointermove', this.onPointerMove);
      this.mediaLink.removeEventListener('click', this.onMediaClick);
      this.pager.removeEventListener('click', this.onPagerClick);

      if (this.productBlock) {
        this.productBlock.removeEventListener('click', this.onSwatchClick);
        this.productBlock.removeEventListener('keyup', this.onSwatchKeyup);
      }

      this.track.remove();
      this.pager.remove();
      this.track = null;
      this.pager = null;
      this.slides = [];
      this.pagerButtons = [];
      this.gridImageObserver = null;
      this.activeIndex = 0;
      this.horizontalDrag = false;
      this.scrollFrame = null;
      this.snapTimer = null;
      this.visibleImage = null;
      this.visibleImageSource = '';
      this.mounted = false;
    }

    onScroll() {
      if (this.snapTimer) window.clearTimeout(this.snapTimer);
      this.snapTimer = window.setTimeout(this.onScrollEnd, 140);

      if (this.scrollFrame) return;

      this.scrollFrame = window.requestAnimationFrame(function () {
        var trackLeft = this.track.getBoundingClientRect().left;
        var closestDistance = Infinity;
        var closestIndex = 0;

        this.slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.setActive(closestIndex);
        this.scrollFrame = null;
      }.bind(this));
    }

    onScrollEnd() {
      if (!this.mounted || !this.track || !this.track.clientWidth) return;

      if (this.snapTimer) window.clearTimeout(this.snapTimer);
      this.snapTimer = null;

      var closestIndex = Math.round(this.track.scrollLeft / this.track.clientWidth);
      closestIndex = Math.max(0, Math.min(closestIndex, this.slides.length - 1));
      this.selectSlide(closestIndex, false);
    }

    onPagerClick(event) {
      var button = event.target.closest('[data-me-collection-card-gallery-index]');
      if (!button || !this.pager.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();
      this.selectSlide(Number(button.getAttribute('data-me-collection-card-gallery-index')), true);
    }

    onPointerDown(event) {
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.horizontalDrag = false;
    }

    onPointerMove(event) {
      var movementX = Math.abs(event.clientX - this.pointerStartX);
      var movementY = Math.abs(event.clientY - this.pointerStartY);

      if (movementX > 8 && movementX > movementY) this.horizontalDrag = true;
    }

    onMediaClick(event) {
      if (!this.horizontalDrag || !this.track.contains(event.target)) return;

      event.preventDefault();
      this.horizontalDrag = false;
    }

    onSwatchClick(event) {
      if (!event.target.closest('[data-deferred-trigger-element]')) return;
      this.selectSlide(0, false);
    }

    onSwatchKeyup(event) {
      if (event.key !== 'Enter' && event.key !== 'NumpadEnter') return;
      if (!event.target.closest('[data-deferred-trigger-element]')) return;
      this.selectSlide(0, false);
    }

    onGridImageMutation(records) {
      if (records && !records.some(function (record) {
        return record.target.matches('[data-grid-image]');
      })) return;

      var visibleImage = this.querySelector('[data-grid-image].product__media--featured-visible');
      var firstSlide = this.slides && this.slides[0];

      if (!visibleImage || !firstSlide) return;

      var visibleImageSource = visibleImage.currentSrc || visibleImage.getAttribute('src') || visibleImage.getAttribute('srcset') || '';
      if (this.visibleImage === visibleImage && this.visibleImageSource === visibleImageSource) return;

      this.visibleImage = visibleImage;
      this.visibleImageSource = visibleImageSource;

      var galleryImage = visibleImage.cloneNode(true);
      galleryImage.removeAttribute('data-grid-image');
      galleryImage.removeAttribute('data-variant-id');
      galleryImage.removeAttribute('data-product-image');
      galleryImage.setAttribute('aria-hidden', 'true');
      firstSlide.replaceChildren(galleryImage);
      this.selectSlide(0, false);
    }

    selectSlide(index, animate) {
      if (!this.mounted || !this.slides[index]) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({
        left: this.slides[index].offsetLeft,
        behavior: animate && !reduceMotion ? 'smooth' : 'auto'
      });
      this.setActive(index);
    }

    setActive(index) {
      if (!this.pagerButtons || !this.pagerButtons[index] || this.activeIndex === index && this.pagerButtons[index].getAttribute('aria-current') === 'true') return;

      this.activeIndex = index;
      this.pagerButtons.forEach(function (button, buttonIndex) {
        if (buttonIndex === index) {
          button.setAttribute('aria-current', 'true');
          return;
        }

        button.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get(componentName)) customElements.define(componentName, MECollectionCardGallery);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncComponents);
  } else {
    mobileQuery.addListener(syncComponents);
  }

  syncComponents();
})();

  (function () {
    var componentName = 'product-card-siblings';
    var cardCache = new Map();

    function getCardMarkup(handle, card) {
      if (cardCache.has(handle)) return cardCache.get(handle);

      var root = window.theme && window.theme.routes && window.theme.routes.root || '/';
      var route = root + 'products/' + encodeURIComponent(handle) + '?section_id=api-product-grid-item';
      var currentContent = card.querySelector('.product-grid-item__info, .product-grid-item__image');
      var aosDelay = currentContent && currentContent.getAttribute('data-aos-delay') || '0';
      var aosAnchor = currentContent && currentContent.getAttribute('data-aos-anchor') || (card.id ? '#' + card.id : '');
      var request = fetch(route, {headers: {'X-Requested-With': 'XMLHttpRequest'}})
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load sibling product card');
          return response.text();
        })
        .then(function (markup) {
          return markup
            .replaceAll('||itemAosDelay||', aosDelay)
            .replaceAll('||itemAosAnchor||', aosAnchor);
        })
        .catch(function (error) {
          cardCache.delete(handle);
          throw error;
        });

      cardCache.set(handle, request);
      return request;
    }

    function copyAnimationAttributes(source, target) {
      ['data-aos', 'data-aos-anchor', 'data-aos-delay', 'data-aos-intersection'].forEach(function (attribute) {
        if (source.hasAttribute(attribute)) {
          target.setAttribute(attribute, source.getAttribute(attribute));
        } else {
          target.removeAttribute(attribute);
        }
      });
      target.removeAttribute('data-aos-custom-init');
    }

    function parseCard(markup) {
      var template = document.createElement('template');
      template.innerHTML = markup;
      return template.content.querySelector('[data-api-content] [data-product-block]');
    }

    function preserveQuickViewTrigger(currentImage, replacementImage) {
      var currentTrigger = currentImage.querySelector('[data-button-quick-view][data-initialized]');
      var replacementTrigger = replacementImage.querySelector('[data-button-quick-view]');
      if (!currentTrigger || !replacementTrigger) return;

      ['href', 'aria-label', 'data-handle', 'data-variant-id', 'tabindex'].forEach(function (attribute) {
        if (replacementTrigger.hasAttribute(attribute)) {
          currentTrigger.setAttribute(attribute, replacementTrigger.getAttribute(attribute));
        } else {
          currentTrigger.removeAttribute(attribute);
        }
      });
      currentTrigger.className = replacementTrigger.className;
      currentTrigger.innerHTML = replacementTrigger.innerHTML;
      replacementTrigger.replaceWith(currentTrigger);
    }

    class ProductCardSiblings extends HTMLElement {
      constructor() {
        super();
        this.selectionToken = 0;
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        var link = event.target.closest('[data-product-card-sibling-link]');
        if (!link || !this.contains(link)) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();
        if (link.getAttribute('aria-current') === 'true') return;

        var card = this.closest('[data-product-block]');
        var handle = link.getAttribute('data-product-handle');
        var destination = link.href;
        var restoreFocus = document.activeElement === link;
        if (!card || !handle) {
          window.location.assign(destination);
          return;
        }

        var token = ++this.selectionToken;
        card.classList.add('is-loading-sibling');
        card.setAttribute('aria-busy', 'true');

        getCardMarkup(handle, card)
          .then(function (markup) {
            if (token !== this.selectionToken) return;

            var replacementCard = parseCard(markup);
            var currentImage = card.querySelector('.product-grid-item__image');
            var currentInfo = card.querySelector('.product-grid-item__info');
            var replacementImage = replacementCard && replacementCard.querySelector('.product-grid-item__image');
            var replacementInfo = replacementCard && replacementCard.querySelector('.product-grid-item__info');
            if (!replacementCard || !currentImage || !currentInfo || !replacementImage || !replacementInfo) {
              throw new Error('Sibling product card response is incomplete');
            }

            copyAnimationAttributes(currentImage, replacementImage);
            copyAnimationAttributes(currentInfo, replacementInfo);
            preserveQuickViewTrigger(currentImage, replacementImage);
            currentImage.replaceWith(replacementImage);
            currentInfo.replaceWith(replacementInfo);

            card.classList.toggle('soldout', replacementCard.classList.contains('soldout'));
            card.setAttribute('data-product-id', replacementCard.getAttribute('data-product-id') || link.getAttribute('data-product-id'));
            card.setAttribute('data-product-handle', handle);
            card.setAttribute('data-product-variant-id', replacementCard.getAttribute('data-product-variant-id') || link.getAttribute('data-variant-id'));

            if (restoreFocus) {
              var nextFocus = Array.prototype.find.call(
                replacementInfo.querySelectorAll('[data-product-card-sibling-link]'),
                function (candidate) {
                  return candidate.getAttribute('data-product-handle') === handle;
                }
              );
              if (nextFocus) nextFocus.focus({preventScroll: true});
            }

            card.dispatchEvent(new CustomEvent('product-card:sibling-change', {
              bubbles: true,
              detail: {
                productId: link.getAttribute('data-product-id'),
                variantId: link.getAttribute('data-variant-id'),
                handle: handle,
                url: destination,
                color: link.getAttribute('data-color-name')
              }
            }));
          }.bind(this))
          .catch(function () {
            if (token === this.selectionToken) window.location.assign(destination);
          }.bind(this))
          .finally(function () {
            if (token !== this.selectionToken) return;
            card.classList.remove('is-loading-sibling');
            card.removeAttribute('aria-busy');
          }.bind(this));
      }
    }

    if (!customElements.get(componentName)) customElements.define(componentName, ProductCardSiblings);
  })();

const matadorRebuyApiKey = 'a28e169399eb05419c3157d68624f352828fd7bd';
const matadorRebuyUuidStorageKey = 'matador_rebuy_uuid';
const matadorRebuyUuidCookieName = 'matador_rebuy_uuid';

function getMatadorRebuyCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));

  return match ? decodeURIComponent(match[1]) : '';
}

function setMatadorRebuyCookie(name, value) {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';

  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
}

function createMatadorRebuyUuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();

  if (window.crypto?.getRandomValues) {
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    return [...bytes].map((byte, index) => {
      const value = byte.toString(16).padStart(2, '0');

      return [4, 6, 8, 10].includes(index) ? `-${value}` : value;
    }).join('');
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.random() * 16 | 0;
    const value = char === 'x' ? random : (random & 0x3 | 0x8);

    return value.toString(16);
  });
}

function storeMatadorRebuyUuid(uuid) {
  if (!uuid) return;

  try {
    window.localStorage.setItem(matadorRebuyUuidStorageKey, uuid);
  } catch (error) {
    // localStorage can be blocked in some privacy modes; the cookie keeps the UUID stable.
  }

  setMatadorRebuyCookie(matadorRebuyUuidCookieName, uuid);
}

function getRebuyUuid() {
  let rebuyIdentity = {};
  let storedUuid = '';

  try {
    storedUuid = window.localStorage.getItem(matadorRebuyUuidStorageKey) || '';
  } catch (error) {
    storedUuid = '';
  }

  storedUuid = storedUuid || getMatadorRebuyCookie(matadorRebuyUuidCookieName);

  if (storedUuid) return storedUuid;

  if (typeof window.Rebuy?.identity === 'function') {
    try {
      rebuyIdentity = window.Rebuy.identity();
    } catch (error) {
      rebuyIdentity = {};
    }
  }

  const uuid = (
    rebuyIdentity?.uuid ||
    window.Rebuy?.uuid ||
    window.Rebuy?.user?.uuid ||
    createMatadorRebuyUuid()
  );

  storeMatadorRebuyUuid(uuid);

  return uuid;
}

function waitForRebuyUuid(callback, attempts) {
  const uuid = getRebuyUuid();
  const currentAttempts = attempts || 0;

  if (uuid || currentAttempts >= 20) {
    callback(uuid);
    return;
  }

  setTimeout(() => waitForRebuyUuid(callback, currentAttempts + 1), 250);
}

function recordRebuyProductView() {
  const productJson = document.querySelector('[data-section-type="product-template"] [data-product-json]');

  if (!productJson || !productJson.textContent) return;

  let product = {};

  try {
    product = JSON.parse(productJson.textContent);
  } catch (error) {
    product = {};
  }

  if (!product.id && !product.handle) return;

  waitForRebuyUuid((uuid) => {
    if (!uuid) return;

    const eventKey = `rebuy-viewed-${uuid}-${product.id || product.handle}`;

    if (window.sessionStorage.getItem(eventKey)) return;

    window.sessionStorage.setItem(eventKey, 'true');

    fetch('https://rebuyengine.com/api/v2/analytics/event', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Rebuy-User-Token': matadorRebuyApiKey
      },
      body: JSON.stringify({
        subject: 'user',
        verb: 'viewed',
        noun: 'product',
        product_id: product.id ? String(product.id) : undefined,
        product_handle: product.handle,
        uuid: uuid,
        customer_id: window.ShopifyAnalytics?.meta?.page?.customerId ? String(window.ShopifyAnalytics.meta.page.customerId) : undefined,
        theme_id: window.Shopify?.theme?.id ? String(window.Shopify.theme.id) : undefined
      })
    }).catch(() => {});
  });
}

recordRebuyProductView();

class RebuyRecommendations extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-rebuy-recommendations-grid]');
    this.uuidAttempts = 0;
    this.emptyAttempts = 0;
    this.resizeHandler = () => this.handleResize();
    if (this.grid && this.dataset.rebuyLayout === 'carousel') {
      this.accessibility = new window.theme.ProductSliderAccessibility(this.grid);
    }
    document.addEventListener('theme:resize:width', this.resizeHandler);
    window.addEventListener('resize', this.resizeHandler);
    this.hideSection();
    this.getProducts();
  }

  disconnectedCallback() {
    document.removeEventListener('theme:resize:width', this.resizeHandler);
    window.removeEventListener('resize', this.resizeHandler);
    this.destroyCarousel();
    this.accessibility?.destroy();
  }

  get uuid() {
    return getRebuyUuid();
  }

  get requestUrl() {
    const type = this.dataset.rebuyRecommendationType;
    const customEndpointId = this.dataset.rebuyCustomEndpointId;
    const params = new URLSearchParams({
      key: this.dataset.rebuyApiKey,
      limit: this.dataset.rebuyLimit || '8'
    });

    if (this.dataset.customerId) params.append('shopify_customer_id', this.dataset.customerId);

    if (type === 'recently_viewed') {
      params.append('uuid', this.uuid);
      params.append('subject', 'user');
      params.append('verb', 'viewed');

      return `https://rebuyengine.com/api/v1/products/viewed?${params}`;
    }

    if (type === 'custom' && customEndpointId) {
      if (this.uuid) params.append('uuid', this.uuid);

      return `https://rebuyengine.com/api/v1/custom/id/${customEndpointId}?${params}`;
    }

    return `https://rebuyengine.com/api/v1/products/recommended?${params}`;
  }

  getProducts() {
    if (!this.grid || !this.dataset.rebuyApiKey) return;

    if (this.dataset.rebuyRecommendationType === 'recently_viewed' && !this.uuid && this.uuidAttempts < 20) {
      this.uuidAttempts += 1;
      setTimeout(() => this.getProducts(), 250);
      return;
    }

    fetch(this.requestUrl)
      .then((response) => response.json())
      .then((data) => {
        const products = data && data.data ? data.data : [];
        const productCards = products.map((product, index) => {
          return fetch(`${window.theme.routes.root}products/${product.handle}?section_id=api-product-grid-item`)
            .then((response) => response.text())
            .then((markup) => {
              return markup
                .replaceAll('||itemAosDelay||', index * 150)
                .replaceAll('||itemAosAnchor||', `#${this.id}`);
            });
        });

        if (!productCards.length) {
          if (this.dataset.rebuyRecommendationType === 'recently_viewed' && this.emptyAttempts < 5) {
            this.emptyAttempts += 1;
            setTimeout(() => this.getProducts(), 2000);
          }

          this.hideSection();
          return;
        }

        Promise.all(productCards).then((cards) => {
          this.destroyCarousel();

          this.grid.innerHTML = cards.map((card) => {
            const holder = document.createElement('div');
            holder.innerHTML = card;
            const apiContent = holder.querySelector('[data-api-content]');
            const productCard = apiContent?.querySelector('[data-product-block]');

            if (productCard) {
              productCard.classList.remove('mobile--one-whole', 'mobile--one-half');
              productCard.classList.add(this.dataset.rebuyColumnsMobile === '2' ? 'mobile--one-half' : 'mobile--one-whole');
            }

            if (this.dataset.rebuyLayout === 'grid' && productCard) {
              productCard.classList.remove('carousel__item');
              productCard.classList.add('grid__item');
              productCard.removeAttribute('data-slide');
            }

            return apiContent?.innerHTML || '';
          }).join('');

          if (this.grid.children.length) {
            this.showSection();
            this.initCarousel();
          } else {
            this.hideSection();
          }
        });
      })
      .catch(() => this.hideSection());
  }

  hideSection() {
    this.classList.add('hidden');
    this.setAttribute('hidden', '');
  }

  showSection() {
    this.classList.remove('hidden');
    this.removeAttribute('hidden');
  }

  destroyCarousel() {
    this.accessibility?.disconnect();
    if (!window.theme?.Flickity) return;

    const existingCarousel = window.theme.Flickity.data(this.grid);

    if (!existingCarousel) return;

    existingCarousel.destroy();
    this.accessibility?.refresh();
  }

  handleResize() {
    if (!this.grid || !this.grid.children.length) return;

    this.initCarousel();
  }

  initCarousel() {
    if (this.dataset.rebuyLayout !== 'carousel') return;
    this.accessibility.refresh();

    if (window.innerWidth < 768) {
      this.destroyCarousel();
      return;
    }

    if (!window.theme?.Flickity) return;

    const existingCarousel = window.theme.Flickity.data(this.grid);

    if (existingCarousel) {
      existingCarousel.resize();
      this.setCarouselArrowsPosition();
      return;
    }

    if (this.grid.querySelectorAll('[data-slide]').length < 2) return;

    this.grid.classList.remove('carousel--inactive');

    const carousel = new window.theme.Flickity(this.grid, {
      pageDots: false,
      cellSelector: '[data-slide]',
      cellAlign: 'left',
      groupCells: true,
      contain: true,
      wrapAround: false,
      adaptiveHeight: false,
      on: {
        ready: () => this.setCarouselArrowsPosition()
      }
    });

    this.accessibility.connect(carousel);

    setTimeout(() => {
      carousel.resize();
      this.setCarouselArrowsPosition();
    }, 0);
  }

  setCarouselArrowsPosition() {
    const image = this.grid.querySelector('[data-product-media-container]');
    const arrows = this.grid.querySelectorAll('.flickity-button');

    if (!image || !arrows.length) return;

    arrows.forEach((arrow) => {
      arrow.style.top = `${image.offsetHeight / 2}px`;
    });
  }

}

if (!customElements.get('rebuy-recommendations')) {
  customElements.define('rebuy-recommendations', RebuyRecommendations);
}



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
